<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>Nudge Console</h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Create Campaign</li>
      </ol>
    </section>

    <section class="content">
      <div ref="pageBox" class="cc-page">
        <campaign-topbar @new-chat="showNewChatDialog = true" @export="exportChat" />
        <campaign-steps-bar :current-step="currentStep" :steps="stepsLabels" />

        <div class="cc-body">
          <chat-panel v-if="showChat" :key="chatInstanceKey" ref="chatPanel" class="cc-chat" :resume-chat-id="resumeChatId" @summary-change="onSummaryChange" />
          <campaign-summary-sidebar class="cc-sidebar" :current-step="currentStep" :summary="summary" />
        </div>
      </div>

      <!-- New Chat Confirmation Dialog -->
      <transition name="cc-overlay-fade">
        <div v-if="showNewChatDialog" class="cc-dialog-overlay" @click.self="showNewChatDialog = false">
          <div class="cc-dialog">
            <h4 class="cc-dialog-title">Start a new chat?</h4>
            <p class="cc-dialog-body">Your current campaign draft will be discarded and a fresh chat will begin.</p>
            <div class="cc-dialog-actions">
              <button class="cc-dialog-btn cc-dialog-btn-cancel" @click="showNewChatDialog = false">No</button>
              <button class="cc-dialog-btn cc-dialog-btn-confirm" @click="confirmNewChat">Yes</button>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>

<script>
import CampaignTopbar from './create-campaign/CampaignTopbar.vue'
import CampaignStepsBar from './create-campaign/CampaignStepsBar.vue'
import ChatPanel from './create-campaign/chat-panel/ChatPanel.vue'
import CampaignSummarySidebar from './create-campaign/summary-sidebar/CampaignSummarySidebar.vue'

import { exportTranscript } from './chatExport'

export default {
  name: 'create-campaign',
  components: {
    CampaignTopbar,
    CampaignStepsBar,
    ChatPanel,
    CampaignSummarySidebar
  },
  data () {
    return {
      showChat: true,
      showNewChatDialog: false,
      chatInstanceKey: 0,
      currentStep: 1,
      summary: { type: null, channels: [] }
    }
  },
  computed: {
    // Dashboard drafts link here with ?chatId= so "Resume" opens the specific draft that
    // was clicked, not whichever incomplete chat happens to be newest (see ChatPanel.vue).
    resumeChatId () {
      return this.$route.query.chatId || null
    },
    // Batch OOS keeps the original 5-step bar; trigger-based flows (always-on, in-session)
    // have no separate audience-build step or send-window step, so they get a shorter one.
    stepsLabels () {
      return this.summary.hideSendWindow
        ? ['Nudge Type', 'Trigger', 'Content', 'Review']
        : ['Nudge Type', 'Audience', 'Content', 'Send Window', 'Review']
    }
  },
  mounted () {
    this._setHeight()
    window.addEventListener('resize', this._setHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this._setHeight)
    if (this.$refs.pageBox) this.$refs.pageBox.style.height = ''
  },
  methods: {
    _setHeight () {
      const el = this.$refs.pageBox
      if (!el) return
      const top = el.getBoundingClientRect().top
      el.style.height = (window.innerHeight - top - 10) + 'px'
    },
    onSummaryChange ({ step, summary }) {
      this.currentStep = step
      this.summary = summary
    },
    async confirmNewChat () {
      this.showNewChatDialog = false
      if (this.$refs.chatPanel && this.$refs.chatPanel.abandonChat) {
        await this.$refs.chatPanel.abandonChat()
      }
      this.chatInstanceKey += 1
      this.currentStep = 1
      this.summary = { type: null, channels: [] }
    },
    exportChat () {
      exportTranscript((this.$refs.chatPanel && this.$refs.chatPanel.messages) || [], 'Campaign Chat')
    }
  }
}
</script>

<style scoped src="./CreateCampaign.css"></style>



// WEBPACK FOOTER //
// CreateCampaign.vue?c856e4aa